/**
 * Copyright (c) samjay.dev.
 *
 * Notes:
 * This source code is the private property of samjay.dev.
 * You cannot modify, share or copy these source codes without any formal authorization,
 * otherwise samjay.dev reserves the right to pursue any legal action.
 *
 * Developer: Sam Tsang (info@samjay.dev)
 */

import React, { useEffect, useState } from 'react'
import {
  Link
} from "react-router-dom"
import NavStyle from '../scss/main/Nav.module.scss'
import moment from 'moment'
import { useSelector } from 'react-redux'
import { RootState } from 'store/types'

interface MainProps {
  toggle: () => void,
  currentPageNum: number
}

const Menu: React.FC<MainProps> = ({
  toggle, currentPageNum
}) => {

  const [isClosing, setClosing] = useState(false);
  const toggleNav = useSelector((state: RootState) => state.ui.toggle!);

  useEffect(() => {
    if (toggleNav === false) {
      setClosing(true)
      setTimeout(() => setClosing(false), 350)
    }
  }, [toggleNav])

  return (
    <div className={`${NavStyle['menu']} ${toggleNav ? `${NavStyle['menu-open']}` : isClosing ? `${NavStyle['menu-closed']}` : ''}`}>
      <div />
      <div>
        <div>
          <div>
            <div>
              Design by Sam TSANG <br />
              © {moment().year()} SAMJAY.DEV
            </div>
            <div>
              <div>
                <Link className={`${currentPageNum === 1 ? NavStyle["active"] : ""}`} to="/blog" onClick={() => toggle() } >Blog</Link>
              </div>
              <div>
                <Link className={`${currentPageNum === 2 ? NavStyle["active"] : ""}`} to="/skills" onClick={() => toggle() } >Skills</Link>
              </div>
              <div>
                <Link className={`${currentPageNum === 3 ? NavStyle["active"] : ""}`} to="/projects" onClick={() => toggle() } >Projects</Link>
              </div>
              <div>
                <Link className={`${currentPageNum === 4 ? NavStyle["active"] : ""}`} to="/contact" onClick={() => toggle() } >Contact</Link>
              </div>
            </div>
          </div>
          <div>
            <div>
              <div>
                Get in touch
              </div>
              <div>
                <a href='mailto:info@samjay.dev?subject=[Enquiry: samjay.dev] Your enquiry title'>
                  info@samjay.dev
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Menu